import { render, staticRenderFns } from "./YieldList.vue?vue&type=template&id=2979a698"
import script from "./YieldList.vue?vue&type=script&lang=js"
export * from "./YieldList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports